import { motion } from 'framer-motion'
import {
  Building2,
  Stethoscope,
  GraduationCap,
  Scale,
  ShoppingBag,
  Briefcase,
  Landmark,
  Cpu,
  Factory,
  Plane,
  Home,
  Utensils,
  Car,
  Tv,
  Dumbbell,
  Leaf,
} from 'lucide-react'
import { cn } from '@personic/shared'

export const INDUSTRIES = [
  { id: 'technology', name: 'Technology', icon: Cpu },
  { id: 'healthcare', name: 'Healthcare', icon: Stethoscope },
  { id: 'finance', name: 'Finance', icon: Landmark },
  { id: 'education', name: 'Education', icon: GraduationCap },
  { id: 'legal', name: 'Legal', icon: Scale },
  { id: 'retail', name: 'Retail', icon: ShoppingBag },
  { id: 'consulting', name: 'Consulting', icon: Briefcase },
  { id: 'manufacturing', name: 'Manufacturing', icon: Factory },
  { id: 'real-estate', name: 'Real Estate', icon: Home },
  { id: 'hospitality', name: 'Hospitality', icon: Utensils },
  { id: 'transportation', name: 'Transportation', icon: Car },
  { id: 'travel', name: 'Travel', icon: Plane },
  { id: 'media', name: 'Media & Entertainment', icon: Tv },
  { id: 'fitness', name: 'Fitness & Wellness', icon: Dumbbell },
  { id: 'agriculture', name: 'Agriculture', icon: Leaf },
  { id: 'other', name: 'Other', icon: Building2 },
] as const

export type IndustryId = typeof INDUSTRIES[number]['id']

interface IndustrySelectorProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

export function IndustrySelector({ value, onChange, className }: IndustrySelectorProps) {
  return (
    <div className={cn('grid grid-cols-2 md:grid-cols-4 gap-3', className)}>
      {INDUSTRIES.map((industry) => {
        const Icon = industry.icon
        const isSelected = value === industry.id

        return (
          <motion.button
            key={industry.id}
            type="button"
            onClick={() => onChange(industry.id)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={cn(
              'flex flex-col items-center justify-center p-4 rounded-xl',
              'border-2 transition-all duration-200',
              'focus:outline-none focus:ring-2 focus:ring-copper-400 focus:ring-offset-2',
              isSelected
                ? 'bg-copper-50 border-copper-500 text-copper-700'
                : 'bg-white border-warm-200 hover:border-copper-300 text-midnight-700'
            )}
          >
            <Icon
              className={cn(
                'w-6 h-6 mb-2',
                isSelected ? 'text-copper-500' : 'text-warm-400'
              )}
            />
            <span className="text-sm font-heading font-medium text-center">
              {industry.name}
            </span>
          </motion.button>
        )
      })}
    </div>
  )
}
